import { Routes } from '@angular/router';
import { BlogLayoutComponent } from './orc-blog-layout/blog-layout.component';
import { BlogListComponent } from './orc-blog-list/blog-list.component';
import { BlogPostComponent } from './orc-blog-post/blog-post.component';
import { blogPostResolver } from './orc-blog-post/blog-post.resolver';

export const blogRoutes: Routes = [
  {
    path: '',
    component: BlogLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: BlogListComponent,
        data: { isHome: true },
      },
      {
        path: 'category/:slug',
        component: BlogListComponent,
      },
      {
        path: 'post/:slug',
        resolve: {
          post: blogPostResolver,
        },
        component: BlogPostComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
